import React from 'react';
import NoContentPage from '../noContent/noContentPage'

const login = () => {
    return (
        <div className="pagina-inicio">
           
            <div className="content">
            <NoContentPage/>
            </div>
        </div>
    );
};

export default login;
